import { PARTNER_MARQUEE, BUSINESS_PARTNERS, SPORTS_PARTNERS } from "@/data/partners";

export default function PartnersMarquee() {
  const items = [...PARTNER_MARQUEE, ...PARTNER_MARQUEE];
  const all = [...BUSINESS_PARTNERS, ...SPORTS_PARTNERS];

  return (
    <section className="relative bg-mist py-24 sm:py-32 overflow-hidden" data-testid="partners-section">
      <div className="container-x">
        <div className="text-center">
          <div className="overline text-emerald-brand">Our partners</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-navy mt-3">
            Brands &amp; institutions we build with.
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {all.map((p) => (
            <div
              key={p.name}
              className={`relative p-8 bg-white border border-slate-200 overflow-hidden group hover:border-navy transition-colors`}
              data-testid={`partner-card-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${p.accent} opacity-0 group-hover:opacity-100 transition-opacity`} />
              <div className="relative">
                <div className="overline text-emerald-brand">{p.category}</div>
                <div className="mt-3 font-display font-bold text-navy text-lg leading-tight">{p.name}</div>
                <p className="mt-3 text-sm text-slate-brand leading-relaxed">{p.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-16 relative">
        <div className="flex w-max marquee-track">
          {items.map((it, i) => (
            <div key={i} className="flex items-center gap-12 px-12 py-6">
              <span className="font-display font-bold text-2xl sm:text-3xl text-navy/40 hover:text-navy transition-colors whitespace-nowrap">
                {it}
              </span>
              <span className="w-2 h-2 rounded-full bg-gold" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
